import styled from 'styled-components';

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const FooterText = styled.div`
  font-weight: 600;
  letter-spacing: -0.03125em;
  margin: 15px 0;
  text-align: center;
`;

export const ReCaptchaWrapper = styled.div`
  padding: 24px 0;
`;

export const EmailWrapper = styled.span`
  font-weight: 400;
`;
